import { BaseTool } from '../BaseTool';
import { useWorksharingStore } from '../../state/useWorksharingStore';
import { notify } from '../../utils/notify';
import i18n from '../../i18n';

/**
 * Interference Check — runs / reviews the clash report between models.
 * Opens the Interference Check dialog; the 'run' payload immediately
 * executes a check against the last configuration (BIM's
 * "Run Interference Check" command behavior).
 */
export class InterferenceCheckTool extends BaseTool {
    id = 'COLLAB_INTERFERENCE';
    name = 'Interference Check';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openCollabDialog('interference');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}

/** Show Last Report — reopens the dialog prefilled with the last run. */
export class ShowLastInterferenceReportTool extends BaseTool {
    id = 'COLLAB_SHOW_LAST_REPORT';
    name = 'Show Last Report';
    cursor = 'default';

    onActivate(): void {
        if (!useWorksharingStore.getState().lastInterferenceReport) {
            notify(i18n.t('tools.notify.noInterferenceCheckHasBeenRun'), 'info');
        }
        this.context?.appStore.openCollabDialog('interference', 'lastReport');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
